/**
 * 政策研究 刊物发布
 * Created at 2021-10-03 12:42
 * @author teapot
 */
import { Image, List, Pagination } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, useHistory } from "react-router-dom";
import Api from "../../api";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { RootState } from "../../app/store";
import HeadView from "../../components/head/HeadView";
import Config from "../../config";
import { DetailsParams } from "../../model/HomeModel";
import { setPolicyCurrent, policyAsync, setPolicySort, setPolicyTime } from "../../store/OtherStore";
import "./index.css";

const Policy = () => {
  const {
    policyArticles,
    policyCategory,
    policyPic,
    policyTitle,
    policyTotal,
    policyCurrent,
    policySort,
    policyTime,
  } = useAppSelector((state: RootState) => state.other);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const access_token = localStorage.getItem('access_token');

  useEffect(() => {
    dispatch(policyAsync({ page: 1, category: 0, time: 0 }));
  }, [dispatch]);

  if (access_token) {
    return (
      <div className="report">
        <HeadView
          title={policyTitle}
          list={policyCategory}
          subTitle={t("policy_book")}
          imgs={`${Config.MAIN_URL}${policyPic}`}
          onPress={(value: string) => {
            const obj = JSON.parse(value);
            if (obj.k === 0) {
              setPolicySort(obj.v);
              dispatch(policyAsync({page: policyCurrent, category: obj.v, time: policyTime}))
            } else {
              setPolicyTime(obj.v);
              dispatch(policyAsync({page: policyCurrent, category: policySort, time: obj.v}))
            }
          }}
        />
  
        <List
          className="report-list"
          dataSource={policyArticles}
          // footer={() => {
          //   return <Pagination defaultCurrent={activityCurrent} total={activityTotal} />;
          // }}
          locale={{emptyText: t('nodata')}}
          renderItem={(item) => (
            <List.Item
              className="report-item report-item-phone"
              onClick={() => {
                if (item.url) {
                  window.location.href = item.url;
                } else if (item.uuid) {
                  history.push("/details", {
                    url: Api.policy_details,
                    uuid: item.uuid,
                    methods: "get",
                  } as DetailsParams);
                }
              }}
            >
              <Image
                className={"report-item-image"}
                src={`${Config.MAIN_URL}${item.img}`}
                preview={false}
              />
              <div className="report-item-right report-item-right-left movepolicy">
                <div className="news-item-image-title news-item-image-title-phone leftnone"> {item.author} </div>
                {item.publish ? (
                  <div className="policy-item-time ">
                    {dayjs(item.publish).format("YYYY-MM-DD")}
                  </div>
                ) : null}
                <div className="tinktank-item-middle-content tinktank-item-middle-content-phone policy-color">{item.article}</div>
              </div>
            </List.Item>
          )}
        />
  
        <div className="report-pagination">
          <Pagination
            defaultCurrent={1}
            current={policyCurrent}
            total={policyTotal}
            pageSize={10}
            onChange={(page) => {
              dispatch(setPolicyCurrent(page));
              dispatch(
                policyAsync({ page, category: policySort, time: policyTime })
              );
            }}
          />
        </div>
      </div>
    );
  } else {
    return <Redirect to='/login' />
  }
};

export default Policy;
